
// Declare global document events
define('common',['jquery', 'bootstrap', 'bootbox', 'knockout'], function ($, bootstrap, bootbox, ko) {
    $(document).ready(function () {
        var $datePicker = $('.datePicker');
        if ($datePicker && $datePicker.datepicker) {
            $datePicker.datepicker();
        }

        $(document).on("click", ".show-remote-modal", function (e) {
            var modal = $($(this).data("target")), modalBody = modal.find('.modal-body');
            var modalTitle = modal.find('.modal-title');
            var modalDialog = modal.find('.modal-dialog');
            var modalContent = modal.find('.modal-content');

            modalTitle.html($(this).data("title"));

            var isFullScreen = $(this).data("fullscreen");

            modal.on('show.bs.modal', function () {
                modalBody.load(e.currentTarget.href, function () {
                    if (isFullScreen === true) {
                        modalDialog.width($(".container").width());
                        modalDialog.height("100%");
                        modalDialog.css("padding", "0");
                        modalDialog.css("margin", "0 auto");
                        modalContent.height("100%");
                        modalContent.css("overflow-y", "auto");
                    } else {
                        modalDialog.width("600px");
                        modalBody.height("auto");
                        modalDialog.height("auto");
                        modalContent.height("auto");
                    }
                });
            }).modal();

            // if there's an iframe in modal
            modal.on('shown.bs.modal', function () {
                var iframe = modal.find("iframe");
                if (iframe.length) {
                    var frameHeight = $(document).height() - iframe.offset().top - 30;
                    modalBody.height(frameHeight);
                    iframe.height(frameHeight);
                }
            });

            e.preventDefault();
        });

        $(document).ajaxSend(function (event, request, settings) {
            if (settings.url.indexOf("ViewPatientsFilter") >= 0
                || settings.url.indexOf("ReportSummaryData") >= 0
                || settings.url.indexOf("DiagnosisSearch") >= 0
                || settings.url.indexOf("EnrolledPatientsFilter") >= 0
                || settings.url.indexOf("EnrollmentForm") >= 0
                || settings.url.indexOf("ViewPhysiciansFilter") >= 0
                || settings.url.indexOf("GetViewPatientsSubGrid") >= 0
                || settings.url.indexOf("SearchReportsFilter") >= 0
                || settings.url.indexOf("MCTStatus") >= 0
                || settings.url.indexOf("InventoryStatus") >= 0
                || settings.url.indexOf("GetDevicePatients") >= 0
                || settings.url.indexOf("GetUserFacilityDetails") >= 0
                || settings.url.indexOf("SaveFacilityHours") >= 0
                || settings.url.indexOf("BillingSummarySearch") >= 0
                || settings.url.indexOf("Enrollment") >= 0
                || settings.url.indexOf("RemoveQueuedEnrollment") >= 0
                || settings.url.indexOf("MarkReportAsRead") >= 0
                || settings.url.indexOf("MarkStudyExported") >= 0
                // || settings.url.indexOf("ConfirmStudy") >= 0
                || settings.url.indexOf("UnconfirmStudy") >= 0
                || settings.url.indexOf("GetFacilityDetails") >= 0
               // || settings.url.indexOf("SaveStudyInterp") >= 0
               // || settings.url.indexOf("SaveEventComment") >= 0
               // || settings.url.indexOf("SaveCommentAndMarkRead") >= 0
                || settings.url.indexOf("GetPhysicianInformation") >= 0
                || settings.url.indexOf("GetDeviceModelFacilities") >= 0
                || settings.url.indexOf("GetFacilitySalesRepsInfo") >= 0)
            {
                $(".ajaxLoader").fadeIn();
            }
        }).ajaxStop(function () {
            $(".ajaxLoader").fadeOut();
        });

        $(document).on("click", ".toggler", function () {
            $(this).toggleText($(this).data("expandtext"), $(this).data("collapsetext"));
            var target = $(this).data("target");
            $(target).slideToggle('fast');
        });
        
        $(document).on("change", ".allcaps", function () {
            
            this.value = this.value.toUpperCase();
        });

        //$(document).on("change", ".phone", function () {
        //    var digits = this.value.match(/\d+/g);
        //    if (digits) {
        //        var ph = digits.join("");
        //        if (ph.length === 10) {
        //            var formatted = ph.substring(0, 3) + "-" + ph.substring(3, 6) + "-" + ph.substring(6);
        //            debugger;
        //            this.value = formatted;
        //        }
        //    }
        //});

        $(document).on("change", ".zip", function () {
            var digits = this.value.match(/\d+/g);
            if (digits) {
                var zip = digits.join("");
                if (zip.length === 9) {
                    var formatted = zip.substring(0, 5) + "-" + zip.substring(5);
                    this.value = formatted;
                }
            }
        });

        $(document).on("change", ".ssn", function () {
            var digits = this.value.match(/\d+/g);
            if (digits) {
                var ssn = digits.join("");
                if (ssn.length === 9) {
                    var formatted = ssn.substring(0, 3) + "-" + ssn.substring(3, 5) + "-" + ssn.substring(5);
                   
                    this.value = formatted;
                    
                }
            }
        });

        $(document).on("change", ".date", function () {
            if (this.value.indexOf(",") > -1) {
                this.value = this.value.substring(this.value.lastIndexOf(",") + 1);
            }
        });

        // button to expand sub-grid (used in View Patients grid)
        $(document).on("click", ".load-subgrid", function () {
            var $this = $(this);
            if ($this.text() === "+") {
                $this.text("-");
                var colCount = $this.closest("tr").find("td").length;
                $.ajax({
                    type: "GET",
                    url: $this.attr('href')
                })
                    .done(function (msg) {
                        $("<tr class='alt' id='grid_r_" + $this.data("id") + "'><td colspan='" + colCount + "'>" + msg + "</td></tr>").insertAfter($this.closest("tr"));
                    });
            } else {
                $this.text("+");
                $this.closest("tr").next().hide();
            }
            return false;
        });

        var ErrorHandlingBindingProvider = function () {
            var original = new ko.bindingProvider();

            this.nodeHasBindings = original.nodeHasBindings;

            this.getBindingAccessors = function (node, bindingContext) {
                var result = {};

                //catch general errors parsing binding syntax
                try {
                    result = original.getBindingAccessors(node, bindingContext);
                }
                catch (e) {
                    $.ajax({
                        type: "POST",
                        url: "/Error/Log",
                        data: { error: "Knockout Error: " + e.message, fullMessage: e }
                    });
                }

                //catch errors when actually evaluating the value of a binding
                ko.utils.objectForEach(result, function (key, value) {
                    result[key] = function () {
                        var result = null;

                        try {
                            result = value();
                        } catch (e) {
                            $.ajax({
                                type: "POST",
                                url: "/Error/Log",
                                data: { error: "Knockout Error: " + e.message, fullMessage: e }
                            });
                        }

                        return result;
                    };
                });

                return result;
            };
        };

        ko.bindingProvider.instance = new ErrorHandlingBindingProvider();


        // Avoid `console` errors in browsers that lack a console.
        (function () {
            var method;
            var noop = function () { };
            var methods = [
                'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
                'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
                'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
                'timeStamp', 'trace', 'warn'
            ];
            var length = methods.length;
            var console = (window.console = window.console || {});

            while (length--) {
                method = methods[length];

                // Only stub undefined methods.
                if (!console[method]) {
                    console[method] = noop;
                }
            }
        }());
    });

    $.fn.extend({
        toggleText: function (a, b) {
            if (this.text() === a) {
                this.text(b);
            } else {
                this.text(a);
            }
        }
    });

    $.fn.showLoaderMessage = function () {
        $('body').append('<div class="text-loader-message">' + this.data("loader-message") + '</div>');
        var loaderDiv = $(".text-loader-message");
        var doc = $(document);
        // center loader spinner
        loaderDiv.css('top', (doc.height() - loaderDiv.height()) / 2)
            .css('left', (doc.width() - loaderDiv.width()) / 2)
            .css("position", "absolute");
    };

    $.fn.serializeObject = function () {
        var o = {};
        var a = this.serializeArray();
        $.each(a, function () {
            if (o[this.name] !== undefined) {
                if (!o[this.name].push) {
                    o[this.name] = [o[this.name]];
                }
                o[this.name].push(this.value || '');
            } else {
                o[this.name] = this.value || '';
            }
        });
        return o;
    };

    
    $.fn.preventDoubleSubmission = function () {
        $(this).on('submit', function (e) {
            var $form = $(this);

            if ($form.data('submitted') === true) {
                // Previously submitted - don't submit again
                e.preventDefault();
            } else {
                // Mark it so that the next submit can be ignored
                $form.data('submitted', true);
            }
        });

        // Keep chainability
        return this;
    };
});
